import {MetricNumericalRenderer} from '../analyticsFormatHelpers';

function shouldWeRenderWholeNumber(value: number): boolean {
  const valueWithSignificantDecimals = Math.abs(value) < 0.1;
  const isValueZero = value === 0;

  return !valueWithSignificantDecimals || isValueZero;
}

function computePercentageValue(
  value: number,
  isCompact: boolean,
  compactThreshold: number,
  shouldRenderOnlyWholeNumbers: boolean,
) {
  if (isCompact && value * 100 > compactThreshold) {
    return `>${compactThreshold}`;
  }

  if (shouldRenderOnlyWholeNumbers) {
    return Math.round(100 * value).toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  }
  return (100 * value).toLocaleString(undefined, {minimumFractionDigits: 1, maximumFractionDigits: 1});
}

export const renderPercentageValue: MetricNumericalRenderer = ({
  value,
  isCompact = false,
  compactThreshold = 1000,
  shouldRenderOnlyWholeNumbers = shouldWeRenderWholeNumber(value),
  isRawVariation,
}) => {
  const suffix = isRawVariation ? 'pp' : '%';
  return `${computePercentageValue(value, isCompact, compactThreshold, shouldRenderOnlyWholeNumbers)}${suffix}`;
};
